import { PAGE_TYPE, CLASSIFICATION_TYPE } from "../../constants";
import { eventPagePayloadCreator } from "../../helpers/eventPayloadCreator";
import { EventData, EventPayload } from "../../types";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GamingPDP3DModelClickedPayload extends EventPayload {
  products?: {
    name?: string;
    slug?: string;
  };
}

const GamingPDP3DModelClickedAnalyticsEvent: EventData = {
  pageType: PAGE_TYPE.gaming,
  eventName: "Gaming PDP 3D Model Clicked",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createGamingPDP3DModeClickedTrackEventPayload = () => {
  return eventPagePayloadCreator<GamingPDP3DModelClickedPayload>(
    GamingPDP3DModelClickedAnalyticsEvent,
  );
};
